<template>
  <div class="portada-xv" ref="rootRef" aria-label="15th Birthday Cover">

    <!-- DECORATIVE FLOWERS -->
    <img src="@/assets/elemento2.png" class="flor flor-1" alt="" />
    <img src="@/assets/elemento2.png" class="flor flor-2" alt="" />
    <img src="@/assets/elemento2.png" class="flor flor-3" alt="" />

    <!-- 🌿 MAGIC BRANCHES -->
    <img src="@/assets/ramas.png" class="rama rama-izq" alt="" />
    <img src="@/assets/ramas.png" class="rama rama-der" alt="" />
    <!-- 🌿 EXTRA BRANCH FOR ARCH -->
    <img src="@/assets/ramas.png" class="rama rama-der-baja" alt="" />

    <!-- 🦋 MAGIC BUTTERFLIES -->
    <img src="@/assets/mariposa.png" class="mariposa mariposa-1" alt="" />
    <img src="@/assets/mariposa.png" class="mariposa mariposa-2" alt="" />
    <img src="@/assets/mariposa.png" class="mariposa mariposa-3" alt="" />
    <img src="@/assets/mariposa.png" class="mariposa mariposa-4" alt="" />

    <!-- SPINNING DISCO BALL -->
    <img src="@/assets/elemento2.png" class="bola bola-izquierda" alt="" />
    <img src="@/assets/ramas.png" class="rama rama-der-baja2" alt="" />
    <img src="@/assets/ramas.png" class="rama rama-der-baja3" alt="" />

    <!-- CROPPED IMAGE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/DSC_1120.webp" class="imagen-xv" alt="Protagonist photo" />
    </div>

    <!-- LOGO
    <img src="@/assets/logito.png" class="logo-portada" alt="Yasmin Logo" />
    -->
    <!-- TEXT -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With the blessing of God <br />
        and my parents:<br><br>
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">Jose Enrique Medel Viveros </h1>
      <h1 class="nombre-protagonista">Janet Garcia Caballero&nbsp; &nbsp;</h1>

      <p class="parrafo-presentacion"><br><br>
        There are moments that define our lives, remaining engraved in our soul and memory.
        Today I am experiencing one of those special moments and I want to share it with those
        who hold a place in my heart.
      </p>
    </section>
  </div>
</template>
<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
      const ramas = [
        '.rama-izq',
        '.rama-der',
        '.rama-der-baja',
        '.rama-der-baja3',
        '.rama-der-baja2'
      ].flatMap($)

      const mariposas = [
        '.mariposa-1',
        '.mariposa-2',
        '.mariposa-3',
        '.mariposa-4'
      ].flatMap($)

      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.parrafo-presentacion'
      ].flatMap($)

      // Estado inicial
      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })

      gsap.set(mariposas, {
        autoAlpha: 0,
        scale: 0.85,
        y: 15,
        filter: 'blur(1px)'
      })

      gsap.set(ramas, {
        autoAlpha: 0,
        scaleY: 0,
        transformOrigin: 'top center',
        filter: 'blur(2px)'
      })

      // Observer
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // FOTO
          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 0.9 }
          )

          // FLORES
          tl.to(
            flores,
            { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.1 },
            '-=0.6'
          )

          // 🦋 MARIPOSAS
          tl.to(
            mariposas,
            {
              autoAlpha: 1,
              y: 0,
              scale: 1,
              filter: 'blur(0px)',
              duration: 0.5,
              stagger: 0.08,
              ease: 'power1.out'
            },
            '-=0.65'
          )

          // 🌿 RAMAS DIBUJADAS
          tl.to(
            ramas,
            {
              autoAlpha: 1,
              scaleY: 1,
              filter: 'blur(0px)',
              duration: 0.7,
              stagger: 0.1,
              ease: 'power2.out'
            },
            '-=0.5'
          )

          // TEXTO
          tl.to(texto, { autoAlpha: 1, y: 0, duration: 0.7, stagger: 0.1 }, '-=0.3')

          // Movimiento orgánico sutil de ramas
          ramas.forEach((r, i) => {
            gsap.to(r, {
              y: i === 0 ? '+=14' : '-=14',
              duration: 3.5,
              yoyo: true,
              repeat: -1,
              ease: 'sine.inOut'
            })
          })

          io.disconnect()
        })
      }, { threshold: 0.15 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>


<style scoped>
.portada-xv{
  position: relative;
  width: 100%;
  min-height: 100vh;

  overflow: visible;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  padding: 48px 16px 56px;
}
@media (max-width: 768px){
  .portada-xv{
    background-attachment: scroll;
  }
}

/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* LOGO CENTRADO */
.logo-portada{
  margin-top: 18px;
  max-width: 140px;
  width: 40vw;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "Playfair Display", serif;
  font-size: 22px;
  color:#6b7c6d;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(16px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 90px) !important;
  z-index:4;
  transform-origin:center;
  will-change: transform, opacity;

  opacity: 0.45;
  filter: blur(0.5px) saturate(0.75) brightness(1.05);
  mix-blend-mode: normal;
  pointer-events: none;
}

.flor-1{
  top:0px;
  left:-70px;
  z-index:1;
  transform: scaleX(-1) rotate(50deg) !important;
  opacity: 0.28;
}

.flor-2{
  top:120px !important;
  right:-80px;
  z-index:1;
  transform: scaleX(-1) rotate(150deg) !important;
  opacity: 0.22;
}

.flor-3{
  bottom:-90px;
  left:-90px;
  z-index:2;
  transform: rotate(-130deg);
  opacity: 0.35;
}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:80px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ right:-2px; bottom:-80px; z-index:9;}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

/* 🌿 RAMAS MAGICAS */
.rama{
  position: absolute;
  width: min(28vw, 180px);
  opacity: 0.45;
  pointer-events: none;
  z-index: 0;
  filter: blur(1.5px) saturate(0.7);
  mix-blend-mode: multiply;
}
.rama{
  height: auto;
  max-height: 720px !important;
}

.rama-izq{
  top: 160px;
  left: -30px;
  transform: rotate(-6deg);
}

.rama-der{
  top: 160px;
  right: -30px;
  transform: scaleX(-1) rotate(-6deg);
}
.rama-der-baja{
  top: 220px;
  right: -30px;
  width: min(30vw, 210px);
  transform: rotate(12deg);
  opacity: 0.38;
}

.rama-der-baja2{
  top: 420px;
  right: -30px;
  width: min(30vw, 210px);
  transform: rotate(12deg);
  opacity: 0.38;
}
.rama-der-baja3{
  top: 620px;
  right: -80px;
  width: min(30vw, 210px);
  transform: rotate(12deg);
  opacity: 0.38;
}

/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}

/* 🦋 MARIPOSAS MAGICAS */
.mariposa{
  position: absolute;
  width: min(16vw, 110px);
  opacity: 0.75;
  pointer-events: none;
  z-index: 3;
  filter: blur(0.2px);
  mix-blend-mode: normal;
  will-change: transform;
}

/* Velocidad media equilibrada y fluida */
.mariposa-1{
  left: 10%;
  top: 0%;
  animation: aleteoMedio 1.8s ease-in-out infinite;
}

.mariposa-2{
  right: 2%;
  top: 52%;
  animation: aleteoMedioInverso 1.6s ease-in-out infinite 0.3s;
}

.mariposa-3{
  left: 18%;
  top: 2%;
  animation: aleteoMedio 2.0s ease-in-out infinite 0.5s;
}

.mariposa-4{
  right: 20%;
  top: 8%;
  animation: aleteoMedioInverso 1.7s ease-in-out infinite 0.2s;
}

/* Movimiento de aleteo nivelado y natural */
@keyframes aleteoMedio {
  0%, 100% {
    transform: scaleX(1);
  }
  50% {
    transform: scaleX(0.7);
  }
}

@keyframes aleteoMedioInverso {
  0%, 100% {
    transform: scaleX(-1);
  }
  50% {
    transform: scaleX(-0.7);
  }
}

/* Mobile: mantener proporción */
@media (max-width: 768px){
  .mariposa{
    opacity: 0.6;
    width: min(18vw, 80px);
  }
}
</style>